<template>
    <b-modal ref="modal" centered :title="$t('WARRANTY')" @close="close()" no-close-on-backdrop no-close-on-esc hide-footer size="lg">
        <div class="d-block mt-2">
          <div role="group" class="b-form-group form-group" v-if="formData != null">
              <div class="form-row mb-lg">
                <div class="col-sm-12">
                  <table class="table table-foursight table-striped table-hover table-sm">
                    <thead>
                      <tr>
                        <th></th>
                        <th>{{$t('NAME')}}</th>
                        <th>{{$t('ACTION')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="item in trainingBlock.root">
                        <tr aria-rowindex="1" class=" table-ellipsis" :key="item.trainingBlockId">
                          <td><a v-if="item.showRow == undefined || item.showRow == false" href="#" v-on:click.prevent="showRow(item)">
                              <icon icon="plus-square" class="icon-grey"></icon>
                            </a><a v-if="item.showRow != undefined && item.showRow == true" href="#" v-on:click.prevent="hideRow(item)">
                              <icon icon="minus-square" class="icon-grey"></icon>
                            </a>
                          </td>
                          <td v-html="item.name"></td>
                          <td>
                            <button type="button" class="btn btn-primary btn-sm" @click="resetBlock(item.trainingBlockId)">{{$t('RESETBLOCK')}}</button>
                          </td>
                        </tr>
                        <tr :key="`${item.trainingBlockId}_sec`" v-if="item.showRow != undefined && item.showRow == true">
                          <td colspan="16" class="sub-bg">
                              <table class="table table-foursight table-striped table-hover table-sm">
                                <thead>
                                  <tr>
                                    <th>{{$t('TITLE')}}</th>
                                    <th>{{$t('ACTION')}}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <template v-for="item in trainingChapters[item.trainingBlockId]">
                                    <tr class=" table-ellipsis" :key="item.chapterId">
                                      <td v-html="item.title"></td>
                                      <td>
                                        <button type="button" class="btn btn-primary btn-sm" @click="resetChapterExam(item.chapterId)">{{$t('RESETCHAPTER')}}</button>
                                      </td>
                                    </tr>
                                  </template>
                                </tbody>
                              </table>
                            </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </div>
          </div>
        </div>

          <div class="text-right">
              <b-btn class="mr-2 button-cancel" @click="close()">{{$t('CANCEL')}}</b-btn>
              <b-btn class="button-save" @click="resetAll()">{{$t('RESETALL')}}</b-btn>
          </div>
    </b-modal>
</template>

<script>
import
{
    mapGetters,
}
    from 'vuex';    
import Api from '@/api/training/TrainingExamCustom'
import ExamApi from '@/api/exam/Exam'

export default
{
    name: 'WarrantyForm',
    props: ['value'],
    data()
    {
        const me = this;

        return {
            trainingBlock: {},
            trainingChapters: {},
            formError: {},
            formData: null,
        };
    },
    methods:
    {
        async showRow(item)
        {
          const me = this;
          await me.getChildern(item);
          me.$set(item, 'showRow', true);
        },
        hideRow(item)
        {
          const me = this;
          me.$set(item, 'showRow', false);
          if (me.trainingChapters[item.trainingBlockId] != null)
          {
            me.trainingChapters[item.trainingBlockId] = {};
          }
        },
        async resetBlock(id)
        {
            const me = this;
            try
            {
                const data = await ExamApi.resetBlock({storeId: me.formData.storeId, trainingBlockId: id});
                me.$notify.notice(data);

                if (data.error)
                {
                    me.formError = data;
                }
            }
            catch (e)
            {
                console.log(e);
                me.$notify.notice(e);
            }
        },
        async resetChapterExam(id)
        {
            const me = this;
            try
            {
                const data = await ExamApi.resetChapter({storeId: me.formData.storeId, trainingChapterId: id});
                me.$notify.notice(data);

                if (data.error)
                {
                    me.formError = data;
                }
            }
            catch (e)
            {
                console.log(e);
                me.$notify.notice(e);
            }
        },
        async resetAll()
        {
            const me = this;
            try
            {
                const data = await ExamApi.resetAll({storeId: me.formData.storeId});
                me.$notify.notice(data);

                if (data.error)
                {
                    me.formError = data;
                }
            }
            catch (e)
            {
                console.log(e);
                me.$notify.notice(e);
            }
        },
        async getChildern(item)
        {
          var me = this;
          try
          {
            var data = await Api.selectTrainingChapter({trainingBlockId: item.trainingBlockId});
            if (data.error && data.error == true)
            {
              me.$notify.notice(data);
              me.loading = false;
              return;
            }

            if (me.trainingChapters[item.trainingBlockId] == null)
            {
              me.trainingChapters[item.trainingBlockId] = [];
            }

            me.trainingChapters[item.trainingBlockId] = data.root;
          }
          catch (e)
          {
            me.$notify.notice(e);
          }
        },
        async getData()
        {
          var me = this;
          try
          {
            var data = await Api.selectTrainingBlock(me.getParams);
            if (data.error && data.error == true)
            {
              me.$notify.notice(data);
              me.loading = false;
              return;
            }

            me.trainingBlock = data;
          }
          catch (e)
          {
            me.$notify.notice(e);
          }
        },
        async submitData(item)
        {
            const me = this;
            try
            {
                if (typeof item.warrantyId !== 'undefined')
                {
                    item.id = item.warrantyId;
                    delete (item.warrantyId);
                }

                const data = await Api.submitData(item);
                me.$notify.notice(data);

                if (data.error)
                {
                    me.formError = data;
                }
                else
                {
                    me.close();
                }
            }
            catch (e)
            {
                console.log(e);
                me.$notify.notice(e);
            }
        },
        close()
        {
            const me = this;
            me.formData = null;
            me.formError = {};
            me.$emit('close');
        },
    },
    watch:
    {
        async formData(val)
        {
            const me = this;
            if (val != null)
            {
                await me.getData();
                me.$refs.modal.show();
            }
            else
            {
                me.$refs.modal.hide();
            }
        },
        value(val)
        {
            const me = this;
            if (val != null)
            {
                me.formData = { ...val };
            }
            else
            {
                me.formData = null;
            }
        },
    },
    computed:
    {
        ...mapGetters([
            'globals',
        ]),
    },
};
</script>
